import { render, staticRenderFns } from "./SalesChannel.vue?vue&type=template&id=378966c6&scoped=true&"
import script from "./SalesChannel.vue?vue&type=script&setup=true&lang=js&"
export * from "./SalesChannel.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./SalesChannel.vue?vue&type=style&index=0&id=378966c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378966c6",
  null
  
)

export default component.exports